import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Homenavbar from '../navbar/index';
import Popup from '../popup/index';

const Homepage = ({ records, setRecords, popupdata, filterdata }) => {
  const [showModal, setShowModal] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchMessage, setSearchMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 38;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://mahboobezaat.com/db_connect.php');
        const sortedData = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setRecords(sortedData);
      } catch (error) {
        console.error("Error fetching data", error);
        setError("Error fetching data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [setRecords]);

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   const day = String(date.getDate()).padStart(2, '0');  
  //   const month = date.toLocaleString('default', { month: 'long' });
  //   const year = date.getFullYear();
  //   return `${day}-${month}-${year}`;
  // };
  
  
  
  

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const displayRecords = filterdata.length > 0 ? filterdata : records;
  const totalRecords = displayRecords.length;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = displayRecords.slice(indexOfFirstRecord, indexOfLastRecord);

  const nextPage = () => setCurrentPage((prevPage) => Math.min(prevPage + 1, Math.ceil(totalRecords / recordsPerPage)));
  const prevPage = () => setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));

  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const hasNextPage = currentPage < totalPages;
  const hasPrevPage = currentPage > 1;

  const renderTableRows = () => {
    if (totalRecords === 1) {
      const item = currentRecords[0];
      return (
        <tr key={0} className="table-row" style={{ cursor: 'pointer' }}>
          <td>{indexOfFirstRecord + 1}</td>
          <td style={{ width: '100%' }} onClick={() => handleRowClick(item)}>
            {`نام${item.name}`}   <b>{item.phone}</b><br />          
            {`پتہ : `}<br />
             {/* <b>تاریخ :</b> <span className="english-text"> {formatDate(item.date)}</span> */}
          </td>
        </tr>
      );
    } else {
      const rows = [];
      for (let i = 0; i < Math.min(currentRecords.length, 30); i += 2) {
        const row = (
          <tr key={i} className="table-row" style={{ cursor: 'pointer' }}>
            {currentRecords[i] && (
              <>
                <td>{indexOfFirstRecord + i + 1}</td>
                <td className='right-half'  onClick={() => handleRowClick(currentRecords[i])}>
                {/* <b>نام</b>  */}
                  <span >{currentRecords[i].name}</span> 
                  <span style={{ marginRight: '6px' }}>{currentRecords[i].phone}</span>
                  <br />               
                  {/* <b>پتہ :</b>  */}
                  {`${currentRecords[i].streetNumber}` } 
                
                  {/* <b>تاریخ :</b> <span className="english-text">{formatDate(currentRecords[i].date)}</span> */}
                </td>
              </>
            )}
            {currentRecords[i + 1] && (
              <>
                <td>{indexOfFirstRecord + i + 2}</td>
                <td className='left-half' onClick={() => handleRowClick(currentRecords[i + 1])}>
                {/* <b>نام</b> <span>{currentRecords[i + 1].name}</span> <span style={{ marginRight: '6px' }}>{currentRecords[i + 1].phone}</span><br /> */}
                <span>{currentRecords[i + 1].name}</span> <span style={{ marginRight: '6px' }}>{currentRecords[i + 1].phone}</span><br />
                  {/* {`پتہ : مکان نمبر ${currentRecords[i + 1].houseNumber} گلی نمبر ${currentRecords[i].streetNumber} ٹاؤن ${currentRecords[i + 1].town} علاقہ ${currentRecords[i + 1].area} ضلع ${currentRecords[i + 1].zilla}`} <b>ڈاک خانہ </b> {currentRecords[i+1].post}<br /> */}
                  {/* <b>پتہ :</b>  */}
                  {`${currentRecords[i+1].streetNumber}` } <br />
                
                {/* <b> تاریخ :</b> <span className="english-text"> {formatDate(currentRecords[i + 1].date)}</span> */}
                </td>
              </>
            )}
          </tr>
        );
        rows.push(row);
      }
      return rows;
    }
  };

  const firstRecordIndex = totalRecords > 0 ? indexOfFirstRecord + 1 : 0;
  const lastRecordIndex = Math.min(indexOfLastRecord, totalRecords);

  return (
    <>
      <Homenavbar setSearchMessage={setSearchMessage} />
      <div className='main custom-bg text-dark urdu-text fs-6'>
        <div className='main-hading'>
          <h5 className='urdu-text fs-2 text-center font-weight-bold pt-4 pb-2 mb-9'>
            <b>آل پاکستان مریدین فہرست حضرت محبوب ذات منڈیر شریف سیداں سیالکوٹ</b>
          </h5>
        </div>
        <div className='main-table' style={{ overflowX: 'auto' }}>
          {searchMessage && (
            <div className="text-center mt-3">
              <p>{searchMessage}</p>
            </div>
          )}
          {!searchMessage && totalRecords > 0 && (
            <table className="table table-bordered">
              <thead>
              </thead>
              <tbody>
                {renderTableRows()}
              </tbody>
            </table>
          )}
          {totalRecords === 0 && !loading && (
            <div className="text-center mt-3">No records found.</div>
          )}
          {loading && (
            <div className="text-center mt-3">Loading...</div>
          )}
          {error && (
            <div className="text-center mt-3 text-danger">{error}</div>
          )}
         <style jsx>{`
  @media (max-width: 768px) {
    table {
      width: 100%;
      border-collapse: collapse;
    }
    .table-row {
      display: block;
      border: 1px solid #ddd;
    }
    .table-row td {
      display: block;
      width: 100%;
      border-bottom: 1px solid #ddd;
    }
    .table-row td:first-child {
      font-weight: bold;
    }
      .table th{
      display:none
      }
  }

  @media print {
    table {
      width: 100%;
    }
    .table-row {
      display: table-row;
    }
    .table-row td {
      display: table-cell;
      width: auto;
      padding: 8px;
    }
    .table-row td:first-child {
      margin-bottom: 0;
      font-weight: normal;
    }
      .pagination-container {
      display: none !important; /* Hide pagination on print */
    }
  }
`}</style>

        </div>

        <div className="pagination-container">
          <nav className='nav-page-container'>
            <ul className="pagination justify-content-center text-center d-flex">
              <li className={`page-item ${!hasPrevPage ? 'disabled' : ''}`}>
                <button onClick={prevPage} className="page-link" disabled={!hasPrevPage}>
                  &laquo; Previous
                </button>
              </li>
              <li className="page-item">
                <span className="page-link" style={{ backgroundColor: 'white', color: 'black' }}>
                  <b>Page {currentPage} of {totalPages}</b>
                </span>
              </li>
              <li className={`page-item ${!hasNextPage ? 'disabled' : ''}`}>
                <button onClick={nextPage} className="page-link" disabled={!hasNextPage}>
                  Next &raquo;
                </button>
              </li>
            </ul>
            <p className="text-center mb-3">
              <b>Showing {firstRecordIndex} - {lastRecordIndex} of {totalRecords} records</b>
            </p>
          </nav>
        </div>
      </div>

      <Popup isOpen={showModal} onClose={handleCloseModal} addRecord={setRecords} selectedItem={selectedItem} />
    </>
  );
};

const mapStateToProps = (state) => ({
  records: state.record.records,
  popupdata: state.popupdata.records,
  filterdata: state.filterdata.filteredrecords,
});

const mapDispatchToProps = (dispatch) => ({
  setRecords: (records) => dispatch({ type: 'SET_RECORDS', payload: records })
});

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);
